import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformModule as CdKPlatformModule } from '@angular/cdk/platform';

@NgModule({
  declarations: [],
  imports: [CommonModule, CdKPlatformModule]
})
export class PlatformModule {}
